// import VT from '@/store/types';

export default {
  // [VT.TIME_LOGS_LIST]: (state, { data, status }) => {
  //   state.timeLogsList = { data, status };
  // },
};
